export default {
  en: {
    'pages.dashboard.title': 'Dashboard',
    'pages.dashboard.hi': 'Hi',
    'pages.dashboard.welcome.back': 'Welcome back',
    'pages.dashboard.welcome': 'Welcome',
    'pages.dashboard.app.open': 'Open',
    'pages.dashboard.vfile.description':
      'Generate and submit VAT returns, EC sales listings within seconds.',
    'pages.dashboard.vlearn.description':
      'All the VAT compliance information you could need in one place.',
    'pages.dashboard.vship.description':
      'Optimise global logistics, transport & shipping at the click of a button.',
    'pages.dashboard.vlearn.noAccess': 'You do not have access to vlearn.',
    'pages.dashboard.vlearn.noAccess-contact': 'Please contact',
    'pages.dashboard.vlearn.noAccess-contact-access': 'to get access.',
  },
};
